export { createHttpErrors, type AppError, type ErrorEntry, type HttpErrorsOptions } from "./create-http-errors";
export { createApiWrapper } from "./create-api-wrapper";
export { createAuthWrapper } from "./create-auth-wrapper";
export { ErrorCatalog, type ErrorKey } from "./error-catalog";

// 공통 카탈로그로 미리 빌드된 버전 — 커스텀 없이 바로 사용 가능
import { createHttpErrors } from "./create-http-errors";
import { createApiWrapper } from "./create-api-wrapper";
import { ErrorCatalog } from "./error-catalog";

const _http = createHttpErrors(ErrorCatalog, {
    onMysqlDupEntry: () => "이미 등록된 데이터입니다.",
});

export const throwHttpError = _http.throwHttpError;
export const createHttpError = _http.createHttpError;
export const errorHandler = _http.errorHandler;
export const apiWrapper = createApiWrapper(_http.errorHandler);
